import { Tag } from "@brg/api";
import { Input } from "@brg/input";
import { CommonInput, CommonLabel, FlexBox, GridBox, INPUT_TYPES, useBreakpoint, useIsMobile } from "@brg/ui";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { LayoutConst, bTag, useModal } from "core";
import { BTag } from "core/components";
import React, { FC, useCallback, useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { MagicBoxRow } from "shared/pages/project/components/toolsStyles";
import { ProjectAddButton } from "shared/pages/projectEdit/ProjectAddButton";
import { ContentAddContainer } from "shared/pages/projectEdit/styles";
import { AlignedTagsGrid } from "shared/pages/projectEdit/styles";
import {
  AddButton,
  ProjectEditPageGridRow
} from "shared/pages/projectEdit/styles";
import {
  DefaultButton,
  GridItem,
  MainFilterContainer,
  MainHeader,
  TeamContextInputWrapper,
  TeamContextListWrapper,
  TeamEditLabel
} from "../styles";
import { DesignerBorder, DesignerNameMob } from "shared/pages/projectEdit/ProjectAuthorsDisplay";
import { BasketIcon } from "shared/pages/projectEdit/BasketIcon";
import { ModerationType } from "../const/ModerationTypes";
import { ModerationType_List, ModuleFormat, ModuleFormatList } from "../TeamEdit";
import { InfoIcon } from "shared/components/InfoIcon/InfoIcon";
import { GtTypes } from "../const/GtTypes";
import { contextOptions } from "../const/ContextOptions";
import CloseIconSmall from "shared/icons/CloseIconSmall";
import {BTagsGridNew} from "../../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { Utils } from "shared/helpers/utils/utils";

export const Item: FC<{ text: string, onClick: () => void }> = ({ text, onClick }) => {

  return (
    <GridItem className={'item-wrapper'}>
      {text}
      
      <span onClick={onClick}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="#151514" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 4L12 12" stroke="#151514" stroke-linecap="round"/>
        <path d="M4 12L12 4" stroke="#151514" stroke-linecap="round"/>
      </svg>
      </span>
    </GridItem>
  )
}

export interface ITeamFilterModel {
  contexts: string[] | null | undefined;
  globalTypes: string[] | null | undefined;
  tagIds: string[] | null | undefined;
  requiredTagIds: string[] | null | undefined;
  exceptedTagIds: string[] | null | undefined;
  tags: Tag[] | null | undefined;
  requiredTags: Tag[] | null | undefined;
  projectIds?: string[];
  exceptedTags: Tag[] | null | undefined;
  mainPage: boolean | null | undefined;
  hasGeotag: boolean | null | undefined;
  hasGeoPlaces: boolean | null | undefined;
  hascities: boolean | null | undefined;
  useCalendar: boolean | null | undefined;
  isContextIgnored: boolean | null | undefined;
  isLite: boolean | null | undefined;
  projectStatus: number[] | null | undefined;
  onlyBooks: boolean;
  moderationTypes: string[] | null | undefined;
  ownerTags: Tag[] | null | undefined;
  rolesList?: string[];
  designerIds?: string[];
  moduleFormat: string[] | null | undefined;
  isPaid: boolean | null | undefined;
}

export type TeamFilterEditPropsT = {
  filter: ITeamFilterModel;
  onChange?: (filter: ITeamFilterModel) => void;
  isMainFilter?: boolean;
  isAdditional?: boolean;
  isModer?: boolean;
  isShopTagsOnly?: boolean;
  isShopEditPage?: boolean;
}

const MAIN_PAGE_OPTIONS = [
  {
    label: 'true',
    value: true,
  },
  {
    label: 'false',
    value: false,
  },
  {
    label: 'none',
    value: null,
  }
]

const ONLY_BOOKS_OPTIONS = [
  {
    label: 'only projects',
    value: false,
  },
  {
    label: 'only books',
    value: true,
  },
  {
    label: 'books & projects',
    value: null,
  }
]

export const TeamFilterEditView: FC<TeamFilterEditPropsT> = (props) => {
  const { t } = useTranslation();
  const modal = useModal();
  const isMobile = useIsMobile();
  const isS = useBreakpoint(LayoutConst.screen.s - 1);

  const { filter, onChange, isModer, isShopTagsOnly } = props;

  const [currentFilter, setCurrentFilter] = useState<ITeamFilterModel>(filter);
  const [contexts, setContexts] = useState<string[]>([]);
  const [projectStatus, setProjectStatus] = useState<string>('');
  const [globalTypes, setGlobalTypes] = useState<string[]>([]);
  const [moderTypes, setModerTypes] = useState<string[]>([]);
  const [moduleFormats, setModuleFormats] = useState<string[]>([]);
  const [contextString, setContextsString] = useState('');

  const showHeader = useMemo(() => (props.isMainFilter), [props.isMainFilter])


  useEffect(() => {
    setGlobalTypes(filter.globalTypes || []);
    setModerTypes(filter.moderationTypes || []);
    setModuleFormats(filter.moduleFormat || []);
  }, []);

  const onFilterChange = useCallback((changedFilter: ITeamFilterModel) => {
    setCurrentFilter(changedFilter);
    if (onChange) onChange(changedFilter);
  }, [onChange]);

  const gtValue = useMemo(() => {
    //@ts-ignore
    return globalTypes.reduce((acc, val) => [...acc, { label: t(`teams.adminPage.labels.${val}`), value: val }], [])
  }, [globalTypes, t])

  const moderTypesValues = useMemo(() => {
    //@ts-ignore
    return moderTypes.reduce((acc, val) => [...acc, { label: Object.values(ModerationType)[val], value: val }], [])
  }, [moderTypes, t])

  const moduleFormatValues = useMemo(() => {
    //@ts-ignore
    return moduleFormats.reduce((acc, val) => [...acc, { label: Object.values(ModuleFormat)[val], value: val }], [])
  }, [moduleFormats, t])

  const gtOptions = useMemo(() => {
    //@ts-ignore
    return GtTypes.reduce((acc, val) => [...acc, {
      label: t(`teams.adminPage.labels.${val?.label}`),
      value: val?.value
    }], [])
  }, [GtTypes, t])

  const contextValues = useMemo(() => {
    //@ts-ignore
    return currentFilter.contexts?.reduce((acc, val) => ([...acc, { label: val, value: val }]), [])
  }, [currentFilter.contexts]);
  const handleKeyPress = (ev: any) => {
    if (ev.key === '4') {
      ev.preventDefault();
    }
  };

  if (isShopTagsOnly) return <MainFilterContainer isShopTagsOnly={isShopTagsOnly} isTeamPage isAdditional>
    <ProjectEditPageGridRow  style={{ marginTop: 24 }} align="flex-start" center={!currentFilter.tags?.length}
                            className={'tags-wrapper mobile-block-6'} isTeamEdit>
      <CommonLabel 
        label={t('teams.adminPage.fields.filter_tags')}
        infoText={t('teams.adminPage.additionalFields.filter_tags_info')}
        fixedHeight
        onWhiteBG
      />
      <FlexBox direction='column' directionMobile={'column'} width={600} widthMobile={isS ? '100%' : 600}>
        <AddButton
            onClick={() => modal.show('tags', {
              value: !!currentFilter.tags?.length ? [...currentFilter.tags] : [],
              ctx: ['products_category'],
              onChange: (tagsRaw: Tag[]) => {
                onFilterChange({ ...currentFilter, tags: tagsRaw });
              },
              isEdit: true,
              global: true,
            })}
            style={{
              marginLeft: 0,
              marginBottom: "auto",
              marginTop: "auto",
              width: '100% !important'
            }}
            fs={true}
        >
          <ProjectAddButton
              text={t('teams.adminPage.buttons.add_or_edit')}
              reverse
          />
        </AddButton>

        {!!currentFilter.tags?.length && (
            <ContentAddContainer fs style={{ marginTop: "16px" }} className={'project-tags-block'}>
              <BTagsGridNew style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                {currentFilter.tags.map((value: any) => (
                    <BTag
                        tag={value}
                        removable
                        onClick={() => modal.show('tags', {
                          value: !!currentFilter.tags?.length ? [...currentFilter.tags] : [],
                          onChange: (tagsRaw: Tag[]) => {
                            onFilterChange({ ...currentFilter, tags: tagsRaw });
                          },
                          isEdit: true,
                          global: true,
                        })}
                        key={value.tagId}
                        educational={value?.isEducationTag}
                    >
                      {bTag.title(value)}
                    </BTag>
                ))}
              </BTagsGridNew>
            </ContentAddContainer>
        )}
      </FlexBox>
    </ProjectEditPageGridRow>
  </MainFilterContainer>


  return (
    <MainFilterContainer isTeamPage isAdditional>
      {/* {!props.isMainFilter && ( */}
      {showHeader && (
        <ProjectEditPageGridRow offsetBottom={56} offsetBottomMobile={24} direction="column" directionMobile="column"
                                gy={16}>
          <MainHeader>{t('teams.adminPage.main_filter')}</MainHeader>
          <span className="header-description">{t('teams.adminPage.additionalFields.main_header_filter_info')}</span>
        </ProjectEditPageGridRow>
      )}
      {isModer ? (
            <FlexBox direction="column" directionMobile="column" width={'100%'} align="center" alignMobile="center">
              <FlexBox width={'100%'} gx={24} gxMobile={16}>
                <CommonInput 
                  type={INPUT_TYPES.text}
                  label={t('teams.adminPage.fields.projects_contexts')}
                  value={contextString}
                  orientation="wide"
                  onChange={(ev: any) => setContextsString(ev.target.value)}
                />
                  {!!contextString?.length && (
                    <DefaultButton wh={195} whMob={195} onClick={() => {
                      //@ts-ignore
                      onFilterChange({
                        ...currentFilter,
                        //@ts-ignore
                        contexts: [...(contextValues ? Object.values(contextValues)?.map(({ value }) => value) : []), contextString]
                      });
                      setContextsString('');
                    }}> {t('teams.adminPage.buttons.add')}</DefaultButton>
                  )}
              </FlexBox>
              {!!contextValues?.length && (
                <FlexBox width={'100%'} offsetTop={24} offsetTopMobile={16}>
                  <GridBox cols={'repeat(5,1fr)'} gap={10}>
                    {/*@ts-ignore*/}
                    {contextValues?.map((item) =>
                      <Item
                        text={item?.value}
                        //@ts-ignore
                        onClick={() => {
                          //@ts-ignore
                          onFilterChange({
                            //@ts-ignore
                            ...currentFilter, contexts: contextValues?.map(({ value }) => value)?.filter((i: any) => {
                              return i !== item?.value
                            })
                          })

                        }}/>
                    )}
                  </GridBox>
                </FlexBox>
              )}
            </FlexBox>
      ) : (

        <FlexBox direction="column" directionMobile="column" width={'100%'} align="center" alignMobile="center">
        <FlexBox width={'100%'} gx={24} gxMobile={16}>
          <CommonInput 
            type={INPUT_TYPES.text}
            label={t('teams.adminPage.fields.projects_contexts')}
            orientation="wide"
            value={contextString}
            onChange={(ev: any) => setContextsString(ev.target.value)}
          />
          {!!contextString?.length && (
                  <DefaultButton wh={195} whMob={195} onClick={() => {
                    //@ts-ignore
                    onFilterChange({
                      ...currentFilter,
                      //@ts-ignore
                      contexts: [...(contextValues ? Object.values(contextValues)?.map(({ value }) => value) : []), contextString]
                    });
                    setContextsString('');
                  }}> {t('teams.adminPage.buttons.add')}</DefaultButton>
                )}
          </FlexBox>       
              {!!contextValues?.length && (
                <FlexBox width={'100%'} offsetTop={24} offsetTopMobile={16}>
                  <GridBox cols={'repeat(5,1fr)'} gap={10}>
                    {/*@ts-ignore*/}
                    {contextValues?.map((item) =>
                      <Item
                        text={item?.value}
                        //@ts-ignore
                        onClick={() => {
                          //@ts-ignore
                          onFilterChange({
                            //@ts-ignore
                            ...currentFilter, contexts: contextValues?.map(({ value }) => value)?.filter((i: any) => {
                              return i !== item?.value
                            })
                          })

                        }}/>
                    )}
                  </GridBox>
                </FlexBox>
              )}
          </FlexBox>
      )}

      <ProjectEditPageGridRow style={{ marginTop: 24 }} isCheckbox isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.context_ignore')}
          infoText={t('teams.adminPage.additionalFields.context_ignored_info')}
          fixedHeight
          onWhiteBG
        />
        <ProjectEditPageGridInput isTeamEdit isCheckbox align="center" alignMobile="center">
          <MagicBoxRow
            className="checkbox"
            checked={!!currentFilter.isContextIgnored}
            label={''}
            onClick={() => onFilterChange({ ...currentFilter, isContextIgnored: !currentFilter.isContextIgnored })}
            isTeamEdit
          />
        </ProjectEditPageGridInput>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.global_types')}
          fixedHeight
          onWhiteBG
        />
        <ProjectEditPageGridInput isTeamEdit>
          <FlexBox direction="column" style={{ width: '100%' }}>
            <Input.Dropdown
              isMulti
              value={gtValue}
              onChange={(value: any) => {
                setGlobalTypes(value.map((i: any) => i?.value));
                onFilterChange({ ...currentFilter, globalTypes: value.map((i: any) => i?.value) });
              }}
              options={gtOptions}
              controlShouldRenderValue={false}
              placeholder={t('teams.adminPage.fields.select_placeholder')}
            />
            {Array.isArray(gtValue) && gtValue.length > 0 && (
              <FlexBox style={{ marginTop: 12, gap: 8, flexWrap: 'wrap' }}>
                {gtValue.map((item: any) => (
                  <Item
                    key={item.value}
                    text={item.label}
                    onClick={() => {
                      const newValue = gtValue.filter((i: any) => i.value !== item.value);
                      setGlobalTypes(newValue.map((i: any) => i?.value));
                      onFilterChange({ ...currentFilter, globalTypes: newValue.map((i: any) => i?.value) });
                    }}
                  />
                ))}
              </FlexBox>
            )}
          </FlexBox>
        </ProjectEditPageGridInput>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.moderation_types')}
          fixedHeight
          onWhiteBG
        />
        <ProjectEditPageGridInput isTeamEdit>
          <Input.Dropdown
            isMulti
            value={moderTypesValues}
            onChange={(value: any) => {
              const hasAutoChannelSign = value.map((i: any) => i?.value)?.includes(ModerationType.ChannelGroupOrCourse)
              setModerTypes(value.map((i: any) => i?.value));
              onFilterChange({ 
                ...currentFilter, 
                moderationTypes: value.map((i: any) => i?.value), 
                ...(hasAutoChannelSign ? {channelNotEmpty: true} : {}) 
              });
            }}
            options={ModerationType_List}
          />
        </ProjectEditPageGridInput>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.module_formats')}
          fixedHeight
          onWhiteBG
        />
        <ProjectEditPageGridInput isTeamEdit>
          <Input.Dropdown
            isMulti
            value={moduleFormatValues}
            onChange={(value: any) => {
              setModuleFormats(value.map((i: any) => i?.value));
              onFilterChange({ ...currentFilter, moduleFormat: value.map((i: any) => i?.value) });
            }}
            options={ModuleFormatList}
          />
        </ProjectEditPageGridInput>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} align="flex-start" center={!currentFilter.tags?.length}
                              className={'tags-wrapper mobile-block-6'} isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.filter_tags')}
          infoText={t('teams.adminPage.additionalFields.filter_tags_info')}
          fixedHeight
          onWhiteBG
        />
        
        <FlexBox direction='column' directionMobile={'column'} width={600} widthMobile={isS ? '100%' : 600}>
          <AddButton
            onClick={() => modal.show('tags', {
              value: !!currentFilter.tags?.length ? [...currentFilter.tags] : [],
              onChange: (tagsRaw: Tag[]) => {
                onFilterChange({ ...currentFilter, tags: tagsRaw });
              },
              isEdit: true,
              global: true,
            })}
            style={{
              marginLeft: 0,
              marginBottom: "auto",
              marginTop: "auto",
              width: '100% !important'
            }}
            fs={true}
          >
            <ProjectAddButton
              text={t('teams.adminPage.buttons.add_or_edit')}
              reverse
            />
          </AddButton>

          {!!currentFilter.tags?.length && (
            <ContentAddContainer fs style={{ marginTop: "16px" }} className={'project-tags-block'}>
              <BTagsGridNew style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                {currentFilter.tags.map((value: any) => (
                  <BTag
                      tag={value}
                    removable
                    onClick={() => modal.show('tags', {
                      value: !!currentFilter.tags?.length ? [...currentFilter.tags] : [],
                      onChange: (tagsRaw: Tag[]) => {
                        onFilterChange({ ...currentFilter, tags: tagsRaw });
                      },
                      isEdit: true,
                      global: true,
                    })}
                    key={value.tagId}
                    educational={value?.isEducationTag}
                  >
                    {bTag.title(value)}
                  </BTag>
                ))}
              </BTagsGridNew>
            </ContentAddContainer>
          )}
        </FlexBox>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} align="flex-start" center={!currentFilter.requiredTags?.length}
                              className={'tags-wrapper mobile-block-6'} isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.filter_tags_required')}
          infoText={t('teams.adminPage.additionalFields.filter_tags_required_info')}
          fixedHeight
          onWhiteBG
        />
        <FlexBox direction='column' directionMobile={'column'} width={600} widthMobile={isS ? '100%' : '600px'}>
          <AddButton
            onClick={() => modal.show('tags', {
              value: !!currentFilter.requiredTags?.length ? [...currentFilter.requiredTags] : [],
              onChange: (tagsRaw: Tag[]) => {
                onFilterChange({ ...currentFilter, requiredTags: tagsRaw });
              },
              isEdit: true,
              global: true,
            })}
            style={{
              marginLeft: 0,
              marginBottom: "auto",
              marginTop: "auto",
              width: '100% !important'
            }}
            fs={true}
          >
            <ProjectAddButton
              text={t('teams.adminPage.buttons.add_or_edit')}
              reverse
            />
          </AddButton>

          {!!currentFilter.requiredTags?.length && (
            <ContentAddContainer fs style={{ marginTop: "16px" }} className={'project-tags-block'}>
              <BTagsGridNew style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                {currentFilter.requiredTags.map((value: any) => (
                  <BTag
                      tag={value}
                    removable
                    onClick={() => modal.show('tags', {
                      value: !!currentFilter.requiredTags?.length ? [...currentFilter.requiredTags] : [],
                      onChange: (tagsRaw: Tag[]) => {
                        onFilterChange({ ...currentFilter, requiredTags: tagsRaw });
                      },
                      isEdit: true,
                      global: true,
                      educational: true,
                    })}
                    key={value.tagId}
                    educational={value?.isEducationTag}
                  >
                    {bTag.title(value)}
                  </BTag>
                ))}
              </BTagsGridNew>
            </ContentAddContainer>
          )}
        </FlexBox>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} align="flex-start" center={!currentFilter.exceptedTags?.length}
                              className={'tags-wrapper mobile-block-6'} isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.filter_tags_excepted')}
          infoText={t('teams.adminPage.additionalFields.filter_tags_excepted_info')}
          fixedHeight
          onWhiteBG
        />
        <FlexBox direction='column' directionMobile={'column'} width={600} widthMobile={isS ? '100%' : 600}>
          <AddButton
            onClick={() => modal.show('tags', {
              value: !!currentFilter.exceptedTags?.length ? [...currentFilter.exceptedTags] : [],
              onChange: (tagsRaw: Tag[]) => {
                onFilterChange({ ...currentFilter, exceptedTags: tagsRaw });
              },
              isEdit: true,
              global: true,
            })}
            style={{
              marginLeft: 0,
              marginBottom: "auto",
              marginTop: "auto",
              width: '100% !important'
            }}
            fs={true}
          >
            <ProjectAddButton
              text={t('teams.adminPage.buttons.add_or_edit')}
              reverse
            />
          </AddButton>

          {!!currentFilter.exceptedTags?.length && (
            <ContentAddContainer fs style={{ marginTop: "16px" }} className={'project-tags-block'}>
              <BTagsGridNew style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                {currentFilter.exceptedTags.map((value: any) => (
                  <BTag
                      tag={value}
                    removable
                    onClick={() => modal.show('tags', {
                      value: !!currentFilter.exceptedTags?.length ? [...currentFilter.exceptedTags] : [],
                      onChange: (tagsRaw: Tag[]) => {
                        onFilterChange({ ...currentFilter, exceptedTags: tagsRaw });
                      },
                      isEdit: true,
                      global: true,
                    })}
                    key={value.tagId}
                    educational={value?.isEducationTag}
                  >
                    {bTag.title(value)}
                  </BTag>
                ))}
              </BTagsGridNew>
            </ContentAddContainer>
          )}
        </FlexBox>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} align="flex-start" center={!currentFilter.ownerTags?.length}
                              className={'tags-wrapper mobile-block-6'} isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.filter_tags_owner')}
          infoText={t('teams.adminPage.additionalFields.filter_tags_owner_info')}
          fixedHeight
          onWhiteBG
        />
        <FlexBox direction='column' directionMobile={'column'} width={600} widthMobile={isS ? '100%' : 600}>
          <AddButton
            onClick={() => modal.show('tags', {
              value: !!currentFilter.ownerTags?.length ? [...currentFilter.ownerTags] : [],
              onChange: (tagsRaw: Tag[]) => {
                onFilterChange({ ...currentFilter, ownerTags: tagsRaw });
              },
              isEdit: true,
              global: true,
            })}
            style={{
              marginLeft: 0,
              marginBottom: "auto",
              marginTop: "auto",
              width: '100% !important'
            }}
            fs={true}
          >
            <ProjectAddButton
              text={t('teams.adminPage.buttons.add_or_edit')}
              reverse
            />
          </AddButton>

          {!!currentFilter.ownerTags?.length && (
            <ContentAddContainer fs style={{ marginTop: "16px" }} className={'project-tags-block'}>
              <BTagsGridNew style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                {currentFilter.ownerTags.map((value: any) => (
                  <BTag
                    tag={value}
                    removable
                    onClick={() => modal.show('tags', {
                      value: !!currentFilter.ownerTags?.length ? [...currentFilter.ownerTags] : [],
                      onChange: (tagsRaw: Tag[]) => {
                        onFilterChange({ ...currentFilter, ownerTags: tagsRaw });
                      },
                      isEdit: true,
                      global: true,
                    })}
                    key={value.tagId}
                    educational={value?.isEducationTag}
                  >
                    {bTag.title(value)}
                  </BTag>
                ))}
              </BTagsGridNew>
            </ContentAddContainer>
          )}
        </FlexBox>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} isCheckbox isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.has_geotag')}
          infoText={t('teams.adminPage.additionalFields.has_geotag_info')}
          fixedHeight
          onWhiteBG
        />
        <ProjectEditPageGridInput isTeamEdit isCheckbox align="center" alignMobile="center">
          <MagicBoxRow
            className="checkbox"
            checked={!!currentFilter.hasGeotag}
            label={''}
            onClick={() => onFilterChange({ ...currentFilter, hasGeotag: !currentFilter.hasGeotag })}
            isTeamEdit
          />
        </ProjectEditPageGridInput>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} isCheckbox isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.has_geoplaces')}
          infoText={t('teams.adminPage.additionalFields.has_geoplaces_info')}
          fixedHeight
          onWhiteBG
        />
        <ProjectEditPageGridInput isTeamEdit isCheckbox align="center" alignMobile="center">
          <MagicBoxRow
            className="checkbox"
            checked={!!currentFilter.hasGeoPlaces}
            label={''}
            onClick={() => onFilterChange({ ...currentFilter, hasGeoPlaces: !currentFilter.hasGeoPlaces })}
            isTeamEdit
          />
        </ProjectEditPageGridInput>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} isCheckbox isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.has_geocities')}
          infoText={t('teams.adminPage.additionalFields.has_geocities_info')}
          fixedHeight
          onWhiteBG
        />
        <ProjectEditPageGridInput isTeamEdit isCheckbox align="center" alignMobile="center">
          <MagicBoxRow
            className="checkbox"
            checked={!!currentFilter.hascities}
            label={''}
            onClick={() => onFilterChange({ ...currentFilter, hascities: !currentFilter.hascities })}
            isTeamEdit
          />
        </ProjectEditPageGridInput>
      </ProjectEditPageGridRow>

    {/* //использовать календарь */}
    <ProjectEditPageGridRow style={{ marginTop: 24 }} isCheckbox isTeamEdit>
      <CommonLabel 
          label={t('teams.adminPage.fields.use_calendar')}
          infoText={t('teams.adminPage.additionalFields.use_calendar_info')}
          fixedHeight
          onWhiteBG
      />
      <ProjectEditPageGridInput isTeamEdit isCheckbox align="center" alignMobile="center">
      <MagicBoxRow
          className="checkbox"
          checked={!!currentFilter.useCalendar}
          label={''}
          onClick={() => {
            const updatedFilter = { ...currentFilter, useCalendar: !currentFilter.useCalendar };
            onFilterChange(updatedFilter); // Применяем изменения фильтра
          }}
          isTeamEdit
        />

      </ProjectEditPageGridInput>
    </ProjectEditPageGridRow>


      <ProjectEditPageGridRow style={{ marginTop: 24 }} isCheckbox isTeamEdit>
        <CommonInput 
          type={INPUT_TYPES.dropdown}
          orientation="wide"
          label={t('teams.adminPage.fields.only_books')}
          infoText={t('teams.adminPage.additionalFields.only_books_info')}
          value={ONLY_BOOKS_OPTIONS.find(({ value }) => {
            if (!currentFilter.hasOwnProperty('onlyBooks')) {
              return value === null
            }
            return value === currentFilter.onlyBooks
          }) as any}
          onChange={({ value }: any) => {
            onFilterChange({ ...currentFilter, onlyBooks: value })
          }}
          options={ONLY_BOOKS_OPTIONS as any}
        />
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} isTeamEdit>
        <ProjectEditPageGridInput isTeamEdit direction="column" directionMobile={'column'}>
          <TeamContextInputWrapper direction={'row'} directionMobile="row" width={'600px'} gx={24}>
            <CommonInput 
              type={INPUT_TYPES.text}
              orientation="wide"
              label={t('teams.adminPage.fields.project_status')}
              onWhiteBG
              infoText={t('teams.adminPage.additionalFields.project_status_info')}
              value={projectStatus}
              // onKeyPress={handleKeyPress}
              onChange={(ev: any) => Utils.isNumber(ev, setProjectStatus)}
            />
            {!!projectStatus?.length && (
              <button onClick={() => {
                onFilterChange({
                  ...currentFilter,
                  projectStatus: [...(currentFilter.projectStatus || []), Number(projectStatus)]
                });
                setProjectStatus('');
              }}>Добавить</button>
            )}
          </TeamContextInputWrapper>
          {!!currentFilter?.projectStatus?.length && (
            <TeamContextListWrapper className={'team-list-wrapper'} offsetTop={16}
                                    style={{ maxWidth: 600, width: '600px !important' }}>
              {currentFilter?.projectStatus?.map((i) => (
                <DesignerNameMob key={`item_${i}`} widthMobile={'100%'} isTeamEdit>
                  <DesignerBorder>
                    <FlexBox className={'text-wrapper'}
                             justifyMobile='space-between' /*widthMobile={'calc(100% - 56px)'}*/ alignMobile={'center'}>
                      {`${i}`}
                    </FlexBox>
                  </DesignerBorder>
                  <FlexBox>
                    <BasketIcon fill={'#909090'} onClick={
                      () => {
                        window.confirm('Вы уверены что хотите удалить данный статус?') && onFilterChange({
                          ...currentFilter,
                          projectStatus: currentFilter?.projectStatus?.filter((k) => k !== i)
                        })
                      }}/>
                  </FlexBox>
                </DesignerNameMob>
              ))}
            </TeamContextListWrapper>)
          }
        </ProjectEditPageGridInput>
      </ProjectEditPageGridRow>
   
      <ProjectEditPageGridRow 
        // @ts-ignore
        style={{ marginTop: 24,  flexDirection: isS ? 'column' : ''}} isCheckbox isTeamEdit>
          <CommonInput 
            type={INPUT_TYPES.dropdown}
            orientation="wide"
            label={'mainPage'}
            infoText={t('teams.adminPage.additionalFields.main_page_info')}
            value={MAIN_PAGE_OPTIONS.find(({ value }) => value === currentFilter.mainPage) as any}
            onChange={(value: any) => {
              onFilterChange({ ...currentFilter, mainPage: value.value })
            }}
            options={MAIN_PAGE_OPTIONS as any}
          />
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24, marginBottom: 120 }} isCheckbox isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.is_paid')}
          infoText={t('teams.adminPage.additionalFields.is_paid_info')}
          fixedHeight
          onWhiteBG
        />
        <ProjectEditPageGridInput isTeamEdit isCheckbox align="center" alignMobile="center">
          <MagicBoxRow
            className="checkbox"
            checked={!!currentFilter.isPaid}
            label={''}
            onClick={() => onFilterChange({ ...currentFilter, isPaid: !currentFilter.isPaid })}
            isTeamEdit
          />
        </ProjectEditPageGridInput>
      </ProjectEditPageGridRow>

    </MainFilterContainer>
  );
};

import { Tag } from "@brg/api";
import { Input } from "@brg/input";
import { CommonInput, CommonLabel, FlexBox, GridBox, INPUT_TYPES, useBreakpoint, useIsMobile } from "@brg/ui";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { LayoutConst, bTag, useModal } from "core";
import { BTag } from "core/components";
import React, { FC, useCallback, useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { MagicBoxRow } from "shared/pages/project/components/toolsStyles";
import { ProjectAddButton } from "shared/pages/projectEdit/ProjectAddButton";
import { ContentAddContainer } from "shared/pages/projectEdit/styles";
import { AlignedTagsGrid } from "shared/pages/projectEdit/styles";
import {
  AddButton,
  ProjectEditPageGridRow
} from "shared/pages/projectEdit/styles";
import {
  DefaultButton,
  GridItem,
  MainFilterContainer,
  MainHeader,
  TeamContextInputWrapper,
  TeamContextListWrapper,
  TeamEditLabel
} from "../styles";
import { DesignerBorder, DesignerNameMob } from "shared/pages/projectEdit/ProjectAuthorsDisplay";
import { BasketIcon } from "shared/pages/projectEdit/BasketIcon";
import { ModerationType } from "../const/ModerationTypes";
import { ModerationType_List, ModuleFormat, ModuleFormatList } from "../TeamEdit";
import { InfoIcon } from "shared/components/InfoIcon/InfoIcon";
import { GtTypes } from "../const/GtTypes";
import { contextOptions } from "../const/ContextOptions";
import CloseIconSmall from "shared/icons/CloseIconSmall";
import {BTagsGridNew} from "../../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { Utils } from "shared/helpers/utils/utils";

export const Item: FC<{ text: string, onClick: () => void }> = ({ text, onClick }) => {

  return (
    <GridItem className={'item-wrapper'}>
      {text}
      
      <span onClick={onClick}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="#151514" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 4L12 12" stroke="#151514" stroke-linecap="round"/>
        <path d="M4 12L12 4" stroke="#151514" stroke-linecap="round"/>
      </svg>
      </span>
    </GridItem>
  )
}

export interface ITeamFilterModel {
  contexts: string[] | null | undefined;
  globalTypes: string[] | null | undefined;
  tagIds: string[] | null | undefined;
  requiredTagIds: string[] | null | undefined;
  exceptedTagIds: string[] | null | undefined;
  tags: Tag[] | null | undefined;
  requiredTags: Tag[] | null | undefined;
  projectIds?: string[];
  exceptedTags: Tag[] | null | undefined;
  mainPage: boolean | null | undefined;
  hasGeotag: boolean | null | undefined;
  hasGeoPlaces: boolean | null | undefined;
  hascities: boolean | null | undefined;
  useCalendar: boolean | null | undefined;
  isContextIgnored: boolean | null | undefined;
  isLite: boolean | null | undefined;
  projectStatus: number[] | null | undefined;
  onlyBooks: boolean;
  moderationTypes: string[] | null | undefined;
  ownerTags: Tag[] | null | undefined;
  rolesList?: string[];
  designerIds?: string[];
  moduleFormat: string[] | null | undefined;
  isPaid: boolean | null | undefined;
}

export type TeamFilterEditPropsT = {
  filter: ITeamFilterModel;
  onChange?: (filter: ITeamFilterModel) => void;
  isMainFilter?: boolean;
  isAdditional?: boolean;
  isModer?: boolean;
  isShopTagsOnly?: boolean;
  isShopEditPage?: boolean;
}

const MAIN_PAGE_OPTIONS = [
  {
    label: 'true',
    value: true,
  },
  {
    label: 'false',
    value: false,
  },
  {
    label: 'none',
    value: null,
  }
]

const ONLY_BOOKS_OPTIONS = [
  {
    label: 'only projects',
    value: false,
  },
  {
    label: 'only books',
    value: true,
  },
  {
    label: 'books & projects',
    value: null,
  }
]

export const TeamFilterEditView: FC<TeamFilterEditPropsT> = (props) => {
  const { t } = useTranslation();
  const modal = useModal();
  const isMobile = useIsMobile();
  const isS = useBreakpoint(LayoutConst.screen.s - 1);

  const { filter, onChange, isModer, isShopTagsOnly } = props;

  const [currentFilter, setCurrentFilter] = useState<ITeamFilterModel>(filter);
  const [contexts, setContexts] = useState<string[]>([]);
  const [projectStatus, setProjectStatus] = useState<string>('');
  const [globalTypes, setGlobalTypes] = useState<string[]>([]);
  const [moderTypes, setModerTypes] = useState<string[]>([]);
  const [moduleFormats, setModuleFormats] = useState<string[]>([]);
  const [contextString, setContextsString] = useState('');

  const showHeader = useMemo(() => (props.isMainFilter), [props.isMainFilter])


  useEffect(() => {
    setGlobalTypes(filter.globalTypes || []);
    setModerTypes(filter.moderationTypes || []);
    setModuleFormats(filter.moduleFormat || []);
  }, []);

  const onFilterChange = useCallback((changedFilter: ITeamFilterModel) => {
    setCurrentFilter(changedFilter);
    if (onChange) onChange(changedFilter);
  }, [onChange]);

  const gtValue = useMemo(() => {
    //@ts-ignore
    return globalTypes.reduce((acc, val) => [...acc, { label: t(`teams.adminPage.labels.${val}`), value: val }], [])
  }, [globalTypes, t])

  const moderTypesValues = useMemo(() => {
    //@ts-ignore
    return moderTypes.reduce((acc, val) => [...acc, { label: Object.values(ModerationType)[val], value: val }], [])
  }, [moderTypes, t])

  const moduleFormatValues = useMemo(() => {
    //@ts-ignore
    return moduleFormats.reduce((acc, val) => [...acc, { label: Object.values(ModuleFormat)[val], value: val }], [])
  }, [moduleFormats, t])

  const gtOptions = useMemo(() => {
    //@ts-ignore
    return GtTypes.reduce((acc, val) => [...acc, {
      label: t(`teams.adminPage.labels.${val?.label}`),
      value: val?.value
    }], [])
  }, [GtTypes, t])

  const contextValues = useMemo(() => {
    //@ts-ignore
    return currentFilter.contexts?.reduce((acc, val) => ([...acc, { label: val, value: val }]), [])
  }, [currentFilter.contexts]);
  const handleKeyPress = (ev: any) => {
    if (ev.key === '4') {
      ev.preventDefault();
    }
  };

  if (isShopTagsOnly) return <MainFilterContainer isShopTagsOnly={isShopTagsOnly} isTeamPage isAdditional>
    <ProjectEditPageGridRow  style={{ marginTop: 24 }} align="flex-start" center={!currentFilter.tags?.length}
                            className={'tags-wrapper mobile-block-6'} isTeamEdit>
      <CommonLabel 
        label={t('teams.adminPage.fields.filter_tags')}
        infoText={t('teams.adminPage.additionalFields.filter_tags_info')}
        fixedHeight
        onWhiteBG
      />
      <FlexBox direction='column' directionMobile={'column'} width={600} widthMobile={isS ? '100%' : 600}>
        <AddButton
            onClick={() => modal.show('tags', {
              value: !!currentFilter.tags?.length ? [...currentFilter.tags] : [],
              ctx: ['products_category'],
              onChange: (tagsRaw: Tag[]) => {
                onFilterChange({ ...currentFilter, tags: tagsRaw });
              },
              isEdit: true,
              global: true,
            })}
            style={{
              marginLeft: 0,
              marginBottom: "auto",
              marginTop: "auto",
              width: '100% !important'
            }}
            fs={true}
        >
          <ProjectAddButton
              text={t('teams.adminPage.buttons.add_or_edit')}
              reverse
          />
        </AddButton>

        {!!currentFilter.tags?.length && (
            <ContentAddContainer fs style={{ marginTop: "16px" }} className={'project-tags-block'}>
              <BTagsGridNew style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                {currentFilter.tags.map((value: any) => (
                    <BTag
                        tag={value}
                        removable
                        onClick={() => modal.show('tags', {
                          value: !!currentFilter.tags?.length ? [...currentFilter.tags] : [],
                          onChange: (tagsRaw: Tag[]) => {
                            onFilterChange({ ...currentFilter, tags: tagsRaw });
                          },
                          isEdit: true,
                          global: true,
                        })}
                        key={value.tagId}
                        educational={value?.isEducationTag}
                    >
                      {bTag.title(value)}
                    </BTag>
                ))}
              </BTagsGridNew>
            </ContentAddContainer>
        )}
      </FlexBox>
    </ProjectEditPageGridRow>
  </MainFilterContainer>


  return (
    <MainFilterContainer isTeamPage isAdditional>
      {/* {!props.isMainFilter && ( */}
      {showHeader && (
        <ProjectEditPageGridRow offsetBottom={56} offsetBottomMobile={24} direction="column" directionMobile="column"
                                gy={16}>
          <MainHeader>{t('teams.adminPage.main_filter')}</MainHeader>
          <span className="header-description">{t('teams.adminPage.additionalFields.main_header_filter_info')}</span>
        </ProjectEditPageGridRow>
      )}
      {isModer ? (
            <FlexBox direction="column" directionMobile="column" width={'100%'} align="center" alignMobile="center">
              <FlexBox width={'100%'} gx={24} gxMobile={16}>
                <CommonInput 
                  type={INPUT_TYPES.text}
                  label={t('teams.adminPage.fields.projects_contexts')}
                  value={contextString}
                  orientation="wide"
                  onChange={(ev: any) => setContextsString(ev.target.value)}
                />
                  {!!contextString?.length && (
                    <DefaultButton wh={195} whMob={195} onClick={() => {
                      //@ts-ignore
                      onFilterChange({
                        ...currentFilter,
                        //@ts-ignore
                        contexts: [...(contextValues ? Object.values(contextValues)?.map(({ value }) => value) : []), contextString]
                      });
                      setContextsString('');
                    }}> {t('teams.adminPage.buttons.add')}</DefaultButton>
                  )}
              </FlexBox>
              {!!contextValues?.length && (
                <FlexBox width={'100%'} offsetTop={24} offsetTopMobile={16}>
                  <GridBox cols={'repeat(5,1fr)'} gap={10}>
                    {/*@ts-ignore*/}
                    {contextValues?.map((item) =>
                      <Item
                        text={item?.value}
                        //@ts-ignore
                        onClick={() => {
                          //@ts-ignore
                          onFilterChange({
                            //@ts-ignore
                            ...currentFilter, contexts: contextValues?.map(({ value }) => value)?.filter((i: any) => {
                              return i !== item?.value
                            })
                          })

                        }}/>
                    )}
                  </GridBox>
                </FlexBox>
              )}
            </FlexBox>
      ) : (

        <FlexBox direction="column" directionMobile="column" width={'100%'} align="center" alignMobile="center">
        <FlexBox width={'100%'} gx={24} gxMobile={16}>
          <CommonInput 
            type={INPUT_TYPES.text}
            label={t('teams.adminPage.fields.projects_contexts')}
            orientation="wide"
            value={contextString}
            onChange={(ev: any) => setContextsString(ev.target.value)}
          />
          {!!contextString?.length && (
                  <DefaultButton wh={195} whMob={195} onClick={() => {
                    //@ts-ignore
                    onFilterChange({
                      ...currentFilter,
                      //@ts-ignore
                      contexts: [...(contextValues ? Object.values(contextValues)?.map(({ value }) => value) : []), contextString]
                    });
                    setContextsString('');
                  }}> {t('teams.adminPage.buttons.add')}</DefaultButton>
                )}
          </FlexBox>       
              {!!contextValues?.length && (
                <FlexBox width={'100%'} offsetTop={24} offsetTopMobile={16}>
                  <GridBox cols={'repeat(5,1fr)'} gap={10}>
                    {/*@ts-ignore*/}
                    {contextValues?.map((item) =>
                      <Item
                        text={item?.value}
                        //@ts-ignore
                        onClick={() => {
                          //@ts-ignore
                          onFilterChange({
                            //@ts-ignore
                            ...currentFilter, contexts: contextValues?.map(({ value }) => value)?.filter((i: any) => {
                              return i !== item?.value
                            })
                          })

                        }}/>
                    )}
                  </GridBox>
                </FlexBox>
              )}
          </FlexBox>
      )}

      <ProjectEditPageGridRow style={{ marginTop: 24 }} isCheckbox isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.context_ignore')}
          infoText={t('teams.adminPage.additionalFields.context_ignored_info')}
          fixedHeight
          onWhiteBG
        />
        <ProjectEditPageGridInput isTeamEdit isCheckbox align="center" alignMobile="center">
          <MagicBoxRow
            className="checkbox"
            checked={!!currentFilter.isContextIgnored}
            label={''}
            onClick={() => onFilterChange({ ...currentFilter, isContextIgnored: !currentFilter.isContextIgnored })}
            isTeamEdit
          />
        </ProjectEditPageGridInput>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.global_types')}
          fixedHeight
          onWhiteBG
        />
        <ProjectEditPageGridInput isTeamEdit>
          <FlexBox direction="column" style={{ width: '100%' }}>
            <Input.Dropdown
              isMulti
              value={gtValue}
              onChange={(value: any) => {
                setGlobalTypes(value.map((i: any) => i?.value));
                onFilterChange({ ...currentFilter, globalTypes: value.map((i: any) => i?.value) });
              }}
              options={gtOptions}
              controlShouldRenderValue={false}
              placeholder={t('teams.adminPage.fields.select_placeholder')}
            />
            {Array.isArray(gtValue) && gtValue.length > 0 && (
              <FlexBox style={{ marginTop: 12, gap: 8, flexWrap: 'wrap' }}>
                {gtValue.map((item: any) => (
                  <Item
                    key={item.value}
                    text={item.label}
                    onClick={() => {
                      const newValue = gtValue.filter((i: any) => i.value !== item.value);
                      setGlobalTypes(newValue.map((i: any) => i?.value));
                      onFilterChange({ ...currentFilter, globalTypes: newValue.map((i: any) => i?.value) });
                    }}
                  />
                ))}
              </FlexBox>
            )}
          </FlexBox>
        </ProjectEditPageGridInput>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.moderation_types')}
          fixedHeight
          onWhiteBG
        />
        <ProjectEditPageGridInput isTeamEdit>
          <Input.Dropdown
            isMulti
            value={moderTypesValues}
            onChange={(value: any) => {
              const hasAutoChannelSign = value.map((i: any) => i?.value)?.includes(ModerationType.ChannelGroupOrCourse)
              setModerTypes(value.map((i: any) => i?.value));
              onFilterChange({ 
                ...currentFilter, 
                moderationTypes: value.map((i: any) => i?.value), 
                ...(hasAutoChannelSign ? {channelNotEmpty: true} : {}) 
              });
            }}
            options={ModerationType_List}
          />
        </ProjectEditPageGridInput>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.module_formats')}
          fixedHeight
          onWhiteBG
        />
        <ProjectEditPageGridInput isTeamEdit>
          <Input.Dropdown
            isMulti
            value={moduleFormatValues}
            onChange={(value: any) => {
              setModuleFormats(value.map((i: any) => i?.value));
              onFilterChange({ ...currentFilter, moduleFormat: value.map((i: any) => i?.value) });
            }}
            options={ModuleFormatList}
          />
        </ProjectEditPageGridInput>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} align="flex-start" center={!currentFilter.tags?.length}
                              className={'tags-wrapper mobile-block-6'} isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.filter_tags')}
          infoText={t('teams.adminPage.additionalFields.filter_tags_info')}
          fixedHeight
          onWhiteBG
        />
        
        <FlexBox direction='column' directionMobile={'column'} width={600} widthMobile={isS ? '100%' : 600}>
          <AddButton
            onClick={() => modal.show('tags', {
              value: !!currentFilter.tags?.length ? [...currentFilter.tags] : [],
              onChange: (tagsRaw: Tag[]) => {
                onFilterChange({ ...currentFilter, tags: tagsRaw });
              },
              isEdit: true,
              global: true,
            })}
            style={{
              marginLeft: 0,
              marginBottom: "auto",
              marginTop: "auto",
              width: '100% !important'
            }}
            fs={true}
          >
            <ProjectAddButton
              text={t('teams.adminPage.buttons.add_or_edit')}
              reverse
            />
          </AddButton>

          {!!currentFilter.tags?.length && (
            <ContentAddContainer fs style={{ marginTop: "16px" }} className={'project-tags-block'}>
              <BTagsGridNew style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                {currentFilter.tags.map((value: any) => (
                  <BTag
                      tag={value}
                    removable
                    onClick={() => modal.show('tags', {
                      value: !!currentFilter.tags?.length ? [...currentFilter.tags] : [],
                      onChange: (tagsRaw: Tag[]) => {
                        onFilterChange({ ...currentFilter, tags: tagsRaw });
                      },
                      isEdit: true,
                      global: true,
                    })}
                    key={value.tagId}
                    educational={value?.isEducationTag}
                  >
                    {bTag.title(value)}
                  </BTag>
                ))}
              </BTagsGridNew>
            </ContentAddContainer>
          )}
        </FlexBox>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} align="flex-start" center={!currentFilter.requiredTags?.length}
                              className={'tags-wrapper mobile-block-6'} isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.filter_tags_required')}
          infoText={t('teams.adminPage.additionalFields.filter_tags_required_info')}
          fixedHeight
          onWhiteBG
        />
        <FlexBox direction='column' directionMobile={'column'} width={600} widthMobile={isS ? '100%' : '600px'}>
          <AddButton
            onClick={() => modal.show('tags', {
              value: !!currentFilter.requiredTags?.length ? [...currentFilter.requiredTags] : [],
              onChange: (tagsRaw: Tag[]) => {
                onFilterChange({ ...currentFilter, requiredTags: tagsRaw });
              },
              isEdit: true,
              global: true,
            })}
            style={{
              marginLeft: 0,
              marginBottom: "auto",
              marginTop: "auto",
              width: '100% !important'
            }}
            fs={true}
          >
            <ProjectAddButton
              text={t('teams.adminPage.buttons.add_or_edit')}
              reverse
            />
          </AddButton>

          {!!currentFilter.requiredTags?.length && (
            <ContentAddContainer fs style={{ marginTop: "16px" }} className={'project-tags-block'}>
              <BTagsGridNew style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                {currentFilter.requiredTags.map((value: any) => (
                  <BTag
                      tag={value}
                    removable
                    onClick={() => modal.show('tags', {
                      value: !!currentFilter.requiredTags?.length ? [...currentFilter.requiredTags] : [],
                      onChange: (tagsRaw: Tag[]) => {
                        onFilterChange({ ...currentFilter, requiredTags: tagsRaw });
                      },
                      isEdit: true,
                      global: true,
                      educational: true,
                    })}
                    key={value.tagId}
                    educational={value?.isEducationTag}
                  >
                    {bTag.title(value)}
                  </BTag>
                ))}
              </BTagsGridNew>
            </ContentAddContainer>
          )}
        </FlexBox>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} align="flex-start" center={!currentFilter.exceptedTags?.length}
                              className={'tags-wrapper mobile-block-6'} isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.filter_tags_excepted')}
          infoText={t('teams.adminPage.additionalFields.filter_tags_excepted_info')}
          fixedHeight
          onWhiteBG
        />
        <FlexBox direction='column' directionMobile={'column'} width={600} widthMobile={isS ? '100%' : 600}>
          <AddButton
            onClick={() => modal.show('tags', {
              value: !!currentFilter.exceptedTags?.length ? [...currentFilter.exceptedTags] : [],
              onChange: (tagsRaw: Tag[]) => {
                onFilterChange({ ...currentFilter, exceptedTags: tagsRaw });
              },
              isEdit: true,
              global: true,
            })}
            style={{
              marginLeft: 0,
              marginBottom: "auto",
              marginTop: "auto",
              width: '100% !important'
            }}
            fs={true}
          >
            <ProjectAddButton
              text={t('teams.adminPage.buttons.add_or_edit')}
              reverse
            />
          </AddButton>

          {!!currentFilter.exceptedTags?.length && (
            <ContentAddContainer fs style={{ marginTop: "16px" }} className={'project-tags-block'}>
              <BTagsGridNew style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                {currentFilter.exceptedTags.map((value: any) => (
                  <BTag
                      tag={value}
                    removable
                    onClick={() => modal.show('tags', {
                      value: !!currentFilter.exceptedTags?.length ? [...currentFilter.exceptedTags] : [],
                      onChange: (tagsRaw: Tag[]) => {
                        onFilterChange({ ...currentFilter, exceptedTags: tagsRaw });
                      },
                      isEdit: true,
                      global: true,
                    })}
                    key={value.tagId}
                    educational={value?.isEducationTag}
                  >
                    {bTag.title(value)}
                  </BTag>
                ))}
              </BTagsGridNew>
            </ContentAddContainer>
          )}
        </FlexBox>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} align="flex-start" center={!currentFilter.ownerTags?.length}
                              className={'tags-wrapper mobile-block-6'} isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.filter_tags_owner')}
          infoText={t('teams.adminPage.additionalFields.filter_tags_owner_info')}
          fixedHeight
          onWhiteBG
        />
        <FlexBox direction='column' directionMobile={'column'} width={600} widthMobile={isS ? '100%' : 600}>
          <AddButton
            onClick={() => modal.show('tags', {
              value: !!currentFilter.ownerTags?.length ? [...currentFilter.ownerTags] : [],
              onChange: (tagsRaw: Tag[]) => {
                onFilterChange({ ...currentFilter, ownerTags: tagsRaw });
              },
              isEdit: true,
              global: true,
            })}
            style={{
              marginLeft: 0,
              marginBottom: "auto",
              marginTop: "auto",
              width: '100% !important'
            }}
            fs={true}
          >
            <ProjectAddButton
              text={t('teams.adminPage.buttons.add_or_edit')}
              reverse
            />
          </AddButton>

          {!!currentFilter.ownerTags?.length && (
            <ContentAddContainer fs style={{ marginTop: "16px" }} className={'project-tags-block'}>
              <BTagsGridNew style={{ marginBottom: "0px" }} className={'tags-wrapper-grid-block'}>
                {currentFilter.ownerTags.map((value: any) => (
                  <BTag
                    tag={value}
                    removable
                    onClick={() => modal.show('tags', {
                      value: !!currentFilter.ownerTags?.length ? [...currentFilter.ownerTags] : [],
                      onChange: (tagsRaw: Tag[]) => {
                        onFilterChange({ ...currentFilter, ownerTags: tagsRaw });
                      },
                      isEdit: true,
                      global: true,
                    })}
                    key={value.tagId}
                    educational={value?.isEducationTag}
                  >
                    {bTag.title(value)}
                  </BTag>
                ))}
              </BTagsGridNew>
            </ContentAddContainer>
          )}
        </FlexBox>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} isCheckbox isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.has_geotag')}
          infoText={t('teams.adminPage.additionalFields.has_geotag_info')}
          fixedHeight
          onWhiteBG
        />
        <ProjectEditPageGridInput isTeamEdit isCheckbox align="center" alignMobile="center">
          <MagicBoxRow
            className="checkbox"
            checked={!!currentFilter.hasGeotag}
            label={''}
            onClick={() => onFilterChange({ ...currentFilter, hasGeotag: !currentFilter.hasGeotag })}
            isTeamEdit
          />
        </ProjectEditPageGridInput>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} isCheckbox isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.has_geoplaces')}
          infoText={t('teams.adminPage.additionalFields.has_geoplaces_info')}
          fixedHeight
          onWhiteBG
        />
        <ProjectEditPageGridInput isTeamEdit isCheckbox align="center" alignMobile="center">
          <MagicBoxRow
            className="checkbox"
            checked={!!currentFilter.hasGeoPlaces}
            label={''}
            onClick={() => onFilterChange({ ...currentFilter, hasGeoPlaces: !currentFilter.hasGeoPlaces })}
            isTeamEdit
          />
        </ProjectEditPageGridInput>
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} isCheckbox isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.has_geocities')}
          infoText={t('teams.adminPage.additionalFields.has_geocities_info')}
          fixedHeight
          onWhiteBG
        />
        <ProjectEditPageGridInput isTeamEdit isCheckbox align="center" alignMobile="center">
          <MagicBoxRow
            className="checkbox"
            checked={!!currentFilter.hascities}
            label={''}
            onClick={() => onFilterChange({ ...currentFilter, hascities: !currentFilter.hascities })}
            isTeamEdit
          />
        </ProjectEditPageGridInput>
      </ProjectEditPageGridRow>

    {/* //использовать календарь */}
    <ProjectEditPageGridRow style={{ marginTop: 24 }} isCheckbox isTeamEdit>
      <CommonLabel 
          label={t('teams.adminPage.fields.use_calendar')}
          infoText={t('teams.adminPage.additionalFields.use_calendar_info')}
          fixedHeight
          onWhiteBG
      />
      <ProjectEditPageGridInput isTeamEdit isCheckbox align="center" alignMobile="center">
      <MagicBoxRow
          className="checkbox"
          checked={!!currentFilter.useCalendar}
          label={''}
          onClick={() => {
            const updatedFilter = { ...currentFilter, useCalendar: !currentFilter.useCalendar };
            onFilterChange(updatedFilter); // Применяем изменения фильтра
          }}
          isTeamEdit
        />

      </ProjectEditPageGridInput>
    </ProjectEditPageGridRow>


      <ProjectEditPageGridRow style={{ marginTop: 24 }} isCheckbox isTeamEdit>
        <CommonInput 
          type={INPUT_TYPES.dropdown}
          orientation="wide"
          label={t('teams.adminPage.fields.only_books')}
          infoText={t('teams.adminPage.additionalFields.only_books_info')}
          value={ONLY_BOOKS_OPTIONS.find(({ value }) => {
            if (!currentFilter.hasOwnProperty('onlyBooks')) {
              return value === null
            }
            return value === currentFilter.onlyBooks
          }) as any}
          onChange={({ value }: any) => {
            onFilterChange({ ...currentFilter, onlyBooks: value })
          }}
          options={ONLY_BOOKS_OPTIONS as any}
        />
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24 }} isTeamEdit>
        <ProjectEditPageGridInput isTeamEdit direction="column" directionMobile={'column'}>
          <TeamContextInputWrapper direction={'row'} directionMobile="row" width={'600px'} gx={24}>
            <CommonInput 
              type={INPUT_TYPES.text}
              orientation="wide"
              label={t('teams.adminPage.fields.project_status')}
              onWhiteBG
              infoText={t('teams.adminPage.additionalFields.project_status_info')}
              value={projectStatus}
              // onKeyPress={handleKeyPress}
              onChange={(ev: any) => Utils.isNumber(ev, setProjectStatus)}
            />
            {!!projectStatus?.length && (
              <button onClick={() => {
                onFilterChange({
                  ...currentFilter,
                  projectStatus: [...(currentFilter.projectStatus || []), Number(projectStatus)]
                });
                setProjectStatus('');
              }}>Добавить</button>
            )}
          </TeamContextInputWrapper>
          {!!currentFilter?.projectStatus?.length && (
            <TeamContextListWrapper className={'team-list-wrapper'} offsetTop={16}
                                    style={{ maxWidth: 600, width: '600px !important' }}>
              {currentFilter?.projectStatus?.map((i) => (
                <DesignerNameMob key={`item_${i}`} widthMobile={'100%'} isTeamEdit>
                  <DesignerBorder>
                    <FlexBox className={'text-wrapper'}
                             justifyMobile='space-between' /*widthMobile={'calc(100% - 56px)'}*/ alignMobile={'center'}>
                      {`${i}`}
                    </FlexBox>
                  </DesignerBorder>
                  <FlexBox>
                    <BasketIcon fill={'#909090'} onClick={
                      () => {
                        window.confirm('Вы уверены что хотите удалить данный статус?') && onFilterChange({
                          ...currentFilter,
                          projectStatus: currentFilter?.projectStatus?.filter((k) => k !== i)
                        })
                      }}/>
                  </FlexBox>
                </DesignerNameMob>
              ))}
            </TeamContextListWrapper>)
          }
        </ProjectEditPageGridInput>
      </ProjectEditPageGridRow>
   
      <ProjectEditPageGridRow 
        // @ts-ignore
        style={{ marginTop: 24,  flexDirection: isS ? 'column' : ''}} isCheckbox isTeamEdit>
          <CommonInput 
            type={INPUT_TYPES.dropdown}
            orientation="wide"
            label={'mainPage'}
            infoText={t('teams.adminPage.additionalFields.main_page_info')}
            value={MAIN_PAGE_OPTIONS.find(({ value }) => value === currentFilter.mainPage) as any}
            onChange={(value: any) => {
              onFilterChange({ ...currentFilter, mainPage: value.value })
            }}
            options={MAIN_PAGE_OPTIONS as any}
          />
      </ProjectEditPageGridRow>

      <ProjectEditPageGridRow style={{ marginTop: 24, marginBottom: 120 }} isCheckbox isTeamEdit>
        <CommonLabel 
          label={t('teams.adminPage.fields.is_paid')}
          infoText={t('teams.adminPage.additionalFields.is_paid_info')}
          fixedHeight
          onWhiteBG
        />
        <ProjectEditPageGridInput isTeamEdit isCheckbox align="center" alignMobile="center">
          <MagicBoxRow
            className="checkbox"
            checked={!!currentFilter.isPaid}
            label={''}
            onClick={() => onFilterChange({ ...currentFilter, isPaid: !currentFilter.isPaid })}
            isTeamEdit
          />
        </ProjectEditPageGridInput>
      </ProjectEditPageGridRow>

    </MainFilterContainer>
  );
};

